import { PageRouteBaseConfig } from '@/App/AppRoutes/types';
import { ActionRef } from '@/App/types/actionRef';
import { ScreenRef } from '@/App/types/screenRef';
import { selectLogin } from '@/features/user/login/selectLogin';

export const LoginRouteBase: PageRouteBaseConfig = {
  key: 'login-page',
  path: '/login/:locale?',
  screenRef: ScreenRef.LOGIN,
  actionRef: ActionRef.LOGIN,
  selector: selectLogin,
};
